(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("5bJoo", function(module, exports) {

$parcel$export(module.exports, "addToCartInit", function () { return $3c7130cf8fe80300$export$517d4b1d48e2b11e; });

var $9BQeR = parcelRequire("9BQeR");

var $f1V7L = parcelRequire("f1V7L");

var $9WVoU = parcelRequire("9WVoU");
var $3c7130cf8fe80300$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3c7130cf8fe80300$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3c7130cf8fe80300$export$517d4b1d48e2b11e = function() {
    var products = document.querySelectorAll(".i-product-action");
    products.forEach(function(product) {
        var _a, _b, _c;
        var addToCartButton = product.querySelector(".--js-cart-add");
        var addedToCartMessage = document.querySelector(".pd-content__added-to-cart");
        var productId = (_a = addToCartButton === null || addToCartButton === void 0 ? void 0 : addToCartButton.dataset.productId) !== null && _a !== void 0 ? _a : null;
        var mass = (_b = addToCartButton === null || addToCartButton === void 0 ? void 0 : addToCartButton.dataset.mass) !== null && _b !== void 0 ? _b : null;
        var quantity = (_c = parseInt(addToCartButton === null || addToCartButton === void 0 ? void 0 : addToCartButton.dataset.quantity)) !== null && _c !== void 0 ? _c : 1;
        addToCartButton === null || addToCartButton === void 0 || addToCartButton.addEventListener("click", function(event) {
            return $3c7130cf8fe80300$var$__awaiter(void 0, void 0, void 0, function() {
                var response, data;
                return $3c7130cf8fe80300$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            event.preventDefault();
                            product.classList.add("--loading");
                            if (!productId) {
                                console.log("product id is missing");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                (0, $9BQeR.cartApi).add(productId, mass, quantity)
                            ];
                        case 1:
                            response = _a.sent();
                            if (!response.ok) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 2:
                            data = _a.sent();
                            (0, $9WVoU.rerenderProgresses)(data.progress.remaining, Number(data.progress.percentage));
                            (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                            addedToCartMessage === null || addedToCartMessage === void 0 || addedToCartMessage.classList.add("--open");
                            setTimeout(function() {
                                addedToCartMessage === null || addedToCartMessage === void 0 || addedToCartMessage.classList.remove("--open");
                            }, 1000);
                            _a.label = 3;
                        case 3:
                            product.classList.remove("--loading");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    });
};
$3c7130cf8fe80300$export$517d4b1d48e2b11e();

});
parcelRegister("9BQeR", function(module, exports) {

$parcel$export(module.exports, "cartApi", function () { return $6ff0174b1648b270$export$7352aab6d7a2d16f; });
var $6ff0174b1648b270$var$__assign = undefined && undefined.__assign || function() {
    $6ff0174b1648b270$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ff0174b1648b270$var$__assign.apply(this, arguments);
};
var $6ff0174b1648b270$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6ff0174b1648b270$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6ff0174b1648b270$var$CartApi = /** @class */ function() {
    function CartApi() {
        this.responseSettings = {
            method: "POST"
        };
    }
    CartApi.prototype.makeRequest = function(url, options) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            var response, error_1;
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, $6ff0174b1648b270$var$__assign($6ff0174b1648b270$var$__assign({}, this.responseSettings), options))
                        ];
                    case 1:
                        response = _a.sent();
                        console.log(response);
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 2:
                        error_1 = _a.sent();
                        console.error("An error occurred:", error_1);
                        throw error_1; // Propagate the error for handling at a higher level if needed
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Adds a product to the cart
    CartApi.prototype.add = function(productId, mass, quantity) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/add-product/".concat(productId, "/").concat(mass, "/").concat(quantity), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Changes the quantity of a product in the cart
    CartApi.prototype.change = function(productId, mass, quantity) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/change-product-quantity/".concat(productId, "/").concat(mass, "/").concat(quantity), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Deletes a product from the cart
    CartApi.prototype.delete = function(productId, mass) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/delete-product/".concat(productId, "/").concat(mass), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Deletes all products from the cart
    CartApi.prototype.deleteAll = function() {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/delete-all", {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Processes shipping and delivery for the cart
    CartApi.prototype.shippingAndDelivery = function(body) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            var options;
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        options = {
                            body: body
                        };
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/shipping-and-delivery", options)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Verify if email is already registered
    CartApi.prototype.verifyRegisteredEmail = function(email) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/verify-registered-email/".concat(email), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return CartApi;
}();
var $6ff0174b1648b270$export$7352aab6d7a2d16f = new $6ff0174b1648b270$var$CartApi();

});


parcelRegister("hlTU3", function(module, exports) {

$parcel$export(module.exports, "openModal", function () { return $ca1fc30271ca302f$export$a7f6cffb6b8ba11c; });
$parcel$export(module.exports, "closeModal", function () { return $ca1fc30271ca302f$export$3f6fecd573f3fa48; });
$parcel$export(module.exports, "default", function () { return $ca1fc30271ca302f$export$2e2bcd8739ae039; });
var $ca1fc30271ca302f$var$transitionLength = 300;
var $ca1fc30271ca302f$export$a7f6cffb6b8ba11c = function(modal) {
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
};
var $ca1fc30271ca302f$export$3f6fecd573f3fa48 = function(modal) {
    modal.classList.remove("--open");
    setTimeout(function() {
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
var $ca1fc30271ca302f$var$initTriggers = function() {
    var triggers = document.querySelectorAll("[data-modal-target]");
    triggers.forEach(function(trigger) {
        var _a;
        var modalTarget = document.getElementById((_a = trigger.getAttribute("data-modal-target")) !== null && _a !== void 0 ? _a : "");
        if (modalTarget === null) return;
        trigger.addEventListener("click", function(event) {
            event.preventDefault();
            $ca1fc30271ca302f$export$a7f6cffb6b8ba11c(modalTarget);
        });
    });
};
var $ca1fc30271ca302f$var$initModals = function() {
    var modals = document.querySelectorAll(".c-modal");
    modals.forEach(function(modal) {
        var closeButtons = modal.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", "".concat($ca1fc30271ca302f$var$transitionLength, "ms"));
        closeButtons.forEach(function(closeButton) {
            closeButton.addEventListener("click", function(event) {
                event.preventDefault();
                $ca1fc30271ca302f$export$3f6fecd573f3fa48(modal);
            });
        });
        modal.addEventListener("click", function(event) {
            if (modal == event.target) $ca1fc30271ca302f$export$3f6fecd573f3fa48(modal);
        });
    });
};
// In case needed reinitialize modals
// When something is re rendered
var $ca1fc30271ca302f$var$init = function() {
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
var $ca1fc30271ca302f$export$2e2bcd8739ae039 = $ca1fc30271ca302f$var$init;
$ca1fc30271ca302f$var$init();

});

})();
//# sourceMappingURL=add-to-cart-handle.f46b4a3a.js.map
